import { css as _css } from "@emotion/core";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import Pill from '../pill';
import * as autocompletePropTypes from '../../utils/prop-types';
import * as styles from './selected-items.style';
import useTruncate from '../../utils/use-truncate';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DEFAULT_FONT_SIZE = 5.94;
var OPTION_PADDING = 46;
var COMPONENT_PADDING = 22;
// TODO - use values from fe-brary
var FONT = '14px "Source Sans Pro", sans-serif';
var SelectedItemList = _ref => {
  var behaviour = _ref.behaviour,
    _ref$selectedItems = _ref.selectedItems,
    selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems,
    noFocus = _ref.noFocus,
    singleSelect = _ref.singleSelect,
    isOpen = _ref.isOpen,
    className = _ref.className,
    _ref$getSelectedItemP = _ref.getSelectedItemProps,
    getSelectedItemProps = _ref$getSelectedItemP === void 0 ? () => {} : _ref$getSelectedItemP,
    _ref$removeSelectedIt = _ref.removeSelectedItem,
    removeSelectedItem = _ref$removeSelectedIt === void 0 ? () => {} : _ref$removeSelectedIt;
  var _useTruncate = useTruncate({
      font: FONT,
      fontSize: DEFAULT_FONT_SIZE,
      optionPadding: OPTION_PADDING,
      globalPadding: COMPONENT_PADDING
    }),
    truncate = _useTruncate.truncate,
    containerRef = _useTruncate.containerRef;
  var transform = behaviour === 'truncate' ? truncate : list => list;
  return ___EmotionJSX("ul", {
    className: className,
    ref: containerRef,
    css: /*#__PURE__*/_css([behaviour === 'newline' && styles.newline, behaviour === 'wrap' && styles.wrap, behaviour === 'truncate' && styles.truncate])
  }, singleSelect && !isOpen && selectedItems.length > 0 && ___EmotionJSX("span", getSelectedItemProps({
    index: 0
  }), selectedItems[0].name), !singleSelect && transform(selectedItems).map((selectedItem, index) => ___EmotionJSX("li", _extends({
    key: "".concat(selectedItem.type, "-").concat(selectedItem.id)
  }, getSelectedItemProps({
    selectedItem,
    index
  }), noFocus && {
    tabIndex: null
  }), selectedItem.overflow ? ___EmotionJSX("span", {
    css: styles.overflow,
    title: selectedItem.subitems.map(_ref2 => {
      var name = _ref2.name;
      return name;
    }).join(', ')
  }, selectedItem.name) : ___EmotionJSX(Pill, {
    item: selectedItem,
    onRemove: selectedItem.overflow ? undefined : removeSelectedItem
  }))));
};
SelectedItemList.propTypes = {
  behaviour: PropTypes.oneOf(['newline', 'wrap', 'truncate']),
  selectedItems: autocompletePropTypes.valueList,
  noFocus: PropTypes.bool,
  singleSelect: PropTypes.bool,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  getSelectedItemProps: PropTypes.func,
  removeSelectedItem: PropTypes.func
};
SelectedItemList.defaultProps = {
  behaviour: 'truncate',
  selectedItems: [],
  noFocus: false,
  singleSelect: false,
  isOpen: false,
  className: '',
  getSelectedItemProps: () => {},
  removeSelectedItem: () => {}
};
export default SelectedItemList;